import React from 'react';

export default function DialogObservacoesSPV({ observacao }) {
  return (
    <div>
      <p>{observacao}</p>
    </div>
  );
}